import React from 'react';
import { useQueryParams } from '@/shared/hooks';
import { VerticalName } from '@/shared/types/category';
import { ParamKey } from '@/shared/types/url-params';
import { getVerticalName } from '@/shared/utils/sourcing-marketplace-util';
import RequestRFPButton from '../../Common/RequestRFPButton';
import Image from 'next/image';
import { isEmpty } from 'lodash-es';
import './index.less';

interface IProps {
  isMobile?: boolean;
  vertical: VerticalName;
}

const NoResult = ({ vertical, isMobile }: IProps) => {
  const { queryParams, setQueryParams } = useQueryParams<{}>();

  const searchKey = queryParams.get(ParamKey.SEARCH);
  const isServices = vertical === VerticalName.SERVICES;

  const clearFilters = () => {
    setQueryParams({ [ParamKey.SEARCH]: null });
  };

  return (
    <div className="no-results">
      <div className="no-results-text">
        <Image src="/images/sourcing/search-remove.svg" width={24} height={24} alt="clear search" />
        <div className="text">
          Sorry, there are no results {!isEmpty(searchKey) ? `for "${searchKey}"` : 'to show for this search'}. Try
          again{' '}
          {searchKey && (
            <span className="clear-filters" onClick={clearFilters}>
              by clearing the search
            </span>
          )}
          .
        </div>
      </div>
      <div className="entrypoints">
        <div className="entrypoint" style={{ backgroundColor: isMobile ? '#f5f5f5' : '#ebf5ed' }}>
          <div className="left">
            <span className="title">
              Custom project requests&nbsp;
              {!isEmpty(searchKey) ? `for "${searchKey}"` : ''}
            </span>
            <span className="subtitle">Post a request and suppliers will respond to you within 48 hours</span>
          </div>
          <RequestRFPButton eventContent="sourcing-marketplace" />
        </div>
        {!isMobile && searchKey && (
          <div className="entrypoint">
            <div className="left">
              <span className="title">
                Browse all {vertical || ''}{' '}
                {getVerticalName(isServices ? VerticalName.SERVICES : VerticalName.PRODUCTS)}
              </span>
              <span className="subtitle">
                Browse all {getVerticalName(isServices ? VerticalName.SERVICES : VerticalName.PRODUCTS)} for this
                category and ask for a custom quote.
              </span>
            </div>
            <span onClick={clearFilters} className="view-all-btn">
              View all {getVerticalName(isServices ? VerticalName.SERVICES : VerticalName.PRODUCTS)}
            </span>
          </div>
        )}
      </div>
    </div>
  );
};

export default NoResult;
